function ChartFeedback({
  message,
  isSuccess,
  showResetButton,
  onResetSelections,
}) {
  if (!message) {
    return null
  }

  const alertType = isSuccess ? 'alert-success' : 'alert-danger'
  const iconClass = isSuccess ? 'bi-check-circle' : 'bi-exclamation-triangle'

  return (
    <div className={`alert ${alertType} mb-4 d-flex align-items-center justify-content-between`}>
      <div>
        <i className={`bi ${iconClass} me-2`}></i>
        {message}
      </div>
      {showResetButton && (
        <button className="btn btn-sm btn-outline-secondary" onClick={onResetSelections}>
          <i className="bi bi-arrow-counterclockwise me-1"></i> Reset Selections
        </button>
      )}
    </div>
  )
}

export default ChartFeedback
